import { Box, DashboardModule } from '@domain-group/suit-theme'

import { useFilters } from '@domain-group/react-hooks'

import useAgencyProviderDeadlineGroups from '@hooks/useAgencyProviderDeadlineGroups'

import defaultRequestOptions from '@sections/Admin/packs/SystemManager/defaultRequestOptions'

import AgencyProviderDeadlineGroupListItem from './AgencyProviderDeadlineGroupListItem'

interface AgencyProviderDeadlineGroupsProps {
  agencyId: number,
}

const AgencyProviderDeadlineGroups = (props: AgencyProviderDeadlineGroupsProps) => {
  const { agencyId } = props

  const filterPayload = useFilters()
  const { pageFilters } = filterPayload

  const agencyProviderDeadlineGroupsPayload = useAgencyProviderDeadlineGroups({
    filters: {
      agency_id: agencyId,
      ...pageFilters,
    },
    performHttpRequests: !!agencyId,
    requestOptions: defaultRequestOptions.agencyProviderDeadlineGroup,
  })

  const {
    callbacks: {
      loadMore,
    },
    canLoadMore,
    filteredAgencyProviderDeadlineGroups,
    filteredAgencyProviderDeadlineGroupsCount,
    hasFilteredAgencyProviderDeadlineGroups,
    loading,
  } = agencyProviderDeadlineGroupsPayload

  return (
    <DashboardModule
      loading={loading}
      title="Deadline Groups"
    >
      <Box flexDirection="column">
        {!loading && (
          <DashboardModule.ScrollableSection>
            {hasFilteredAgencyProviderDeadlineGroups && (
              filteredAgencyProviderDeadlineGroups.map(agencyProviderDeadlineGroup => (
                <AgencyProviderDeadlineGroupListItem
                  agencyProviderDeadlineGroup={agencyProviderDeadlineGroup}
                  key={agencyProviderDeadlineGroup.id}
                />
              ))
            )}

            {!hasFilteredAgencyProviderDeadlineGroups && (
              <DashboardModule.BlankState>
                <DashboardModule.BlankState.Title>
                  No Deadline Groups present
                </DashboardModule.BlankState.Title>
              </DashboardModule.BlankState>
            )}
          </DashboardModule.ScrollableSection>
        )}

        <DashboardModule.LoadMoreFooter
          boxProps={{ borderTop: loading ? 'none' : '1px solid' }}
          callbacks={{ loadMore }}
          canLoadMore={canLoadMore}
          entityCount={filteredAgencyProviderDeadlineGroupsCount}
          loading={loading}
        />
      </Box>
    </DashboardModule>
  )
}

export default AgencyProviderDeadlineGroups
